import { handleRequestErrors } from "../services/handleRequestError";
import TagsModelMC from '../presentation/models/TagsModelMC';
import { SIDEBAR_ACTIONS, TAGS_ACTIONS } from "../constants/actionsConstants";

export const getTags = (params) => (dispatch) => {
  dispatch({ type: 'TAGS_LOADING_START' });
  
  TagsModelMC.get(params)
    .then(
      (data) => dispatch({ type: TAGS_ACTIONS.SET_ALL_TAGS, data })
    ).catch((err) => {
      dispatch({ type: 'TAGS_LOADING_ERROR', error: err.message || 'Error loading tags' });
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    });
};

export const createTag = (params, refetch) => (dispatch) => {
  TagsModelMC.save(params)
    .then((data) => {
      dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
      showtoast(data.message);
      refetch();
    })
    .catch(async (err) => {
      if (err.message) {
        err.message?.tag?.map((error) => showtoast(error));
      }
    });
};

export const updateTag = (params, refetch) => (dispatch) => {
  TagsModelMC.save(params)
    .then((data) => {
      dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
      showtoast(data.message);
      refetch();
    })
    .catch((err) => {
      if (err.message) {
        err.message?.tag?.map((error) => showtoast(error));
      }
    });
};

export const createTagFromCustomerDetails = (body) => {
  const endpoint = `/api/v1/tags`;
  return (dispatch) => {
    fetch(endpoint, {
      method: "POST",
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/plain, */*'
      },
      body: JSON.stringify(body)
    })
      .then((res) => handleRequestErrors(res, false))
      .then(
        (data) => dispatch({ type: 'SET_CREATED_NEW_TAG', data })
      ).catch((err) => {
        dispatch({ type: "LOAD_DATA_FAILURE", err });
      });
  };
};
